import { getFromLocalStorage, saveInLocalStorage } from '@/utils/local-storage';
import { defineStore } from 'pinia';
import { CURRENCY } from '@/config/app';

const defaultBranding = {
    business_name: null,
    portal_name: null,
    currency: CURRENCY,
    timezone: null,
    logo_url: null,
    portal_logo_url: null,
};

const initialState = {
    // getFromLocalStorage returns null when the key is absent, so coalesce to defaults.
    branding: getFromLocalStorage('branding', defaultBranding) || defaultBranding,
    fetched: false,
};

export const useSettingsStore = defineStore('settingsStore', {
    state: () => initialState,

    getters: {
        currency: (state) => state.branding?.currency || CURRENCY,
    },

    actions: {
        setBranding(value) {
            this.branding = { ...(this.branding || {}), ...(value || {}) };
            saveInLocalStorage('branding', this.branding);
        },

        setFetched(value) {
            this.fetched = value;
        },
    },
});
